import React, { memo, forwardRef } from "react";
const SvgSquareroot = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={10} height={12} x={17} y={12} fill="#DBDBDB" rx={2} />
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M14.08 8.602a1 1 0 01.919-.606h13a1 1 0 110 2h-12.34L9.918 23.39a1 1 0 01-1.84 0l-2.74-6.394H4a1 1 0 110-2h2a1 1 0 01.92.606l2.08 4.855 5.08-11.855z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgSquareroot.displayName = "SvgSquareroot";
const MemoForwardRef = memo(SvgSquareroot);
export default MemoForwardRef;
